export default {
	name: 'school-work-management',
	path: '/school-work-management',
	redirect: '/school-work-management/result-management/manage',
	meta: {
		title: '校务管理',
		icon: 'icon-school-work-management'
	},
	children: [
		{
			name: 'result-management',
			path: '/school-work-management/result-management/manage',
			fullPath: '/school-work-management/result-management/manage',
			meta: {
				title: '成绩管理',
				icon: 'icon-result-manage'
			},
			component: () =>
				import(/* webpackChunkName: "result-management" */ '@/views/school-work-management/result-management/manage')
		},
		{
			name: 'result-add-edit',
			path: '/result-add-edit',
			fullPath: '/school-work-management/result-management/result-add-edit',
			meta: {
				title: '编辑考试',
				icon: 'icon-result-edit'
			},
			component: () =>
				import(/* webpackChunkName: "result-add-edit" */ '@/views/school-work-management/result-management/manage/add-edit')
		},
		{
			name: 'result-collect',
			path: '/result-collect',
			fullPath: '/school-work-management/result-management/result-collect',
			meta: {
				title: '成绩汇总',
				icon: 'icon-result-collect'
			},
			component: () =>
				import(/* webpackChunkName: "result-collect" */ '@/views/school-work-management/result-management/collect')
		},
		{
			name: 'result-detail',
			path: '/result-detail',
			fullPath: '/school-work-management/result-management/result-detail',
			meta: {
				title: '成绩详情',
				icon: 'icon-result-detail'
			},
			component: () =>
				import(/* webpackChunkName: "result-detail" */ '@/views/school-work-management/result-management/collect/detail')
		},
		{
			name: 'result-import',
			path: '/result-import',
			fullPath: '/school-work-management/result-management/result-import',
			meta: {
				title: '成绩导入',
				icon: 'icon-result-import'
			},
			component: () =>
				import(/* webpackChunkName: "result-import" */ '@/views/school-work-management/result-management/collect/import')
		}
	]
};
